/**
 * App configuration
 * Centralized configuration for app-wide settings
 */

export const APP_CONFIG = {
  downloads: {
    ios: {
      appStoreUrl: 'https://apps.apple.com/de/app/finley/id6754945124',
    },
    android: {
      playStoreUrl: 'https://play.google.com/store/apps/details?id=com.finley.app',
    },
    // Smart deep link that routes the scanning device to the right store (and
    // falls back to /download for unmatched devices). Encoded into the QR codes.
    // Override per-env via NEXT_PUBLIC_APP_LINK.
    smartLink: process.env.NEXT_PUBLIC_APP_LINK || 'https://link.joinfinley.com/app',
  },
}
